import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/common/modal-component';
import { ModalButton } from 'models/utils/common/modal-button-model';

const SUPPORT_ACCESS_DISCLAIMER_BLOCK = 'support-access-disclaimer-modal';
const SUPPORT_ACCESS_DISCLAIMER_ID_BLOCK = 'support-access-disclaimer-modal-id';

export const ViewDisclaimerModal = ({ onClose }) => (
  <Modal
    id={`${SUPPORT_ACCESS_DISCLAIMER_ID_BLOCK}`}
    title={
      'project-creation.manage-users.support-team-access.disclaimer-modal-title'
    }
    primaryModalButton={
      new ModalButton({
        text: 'common.close',
        onClick: onClose,
      })
    }
    onClose={onClose}
  >
    <div className={`${SUPPORT_ACCESS_DISCLAIMER_BLOCK}__para-1`}>
      <FormattedMessage
        id={
          'project-creation.manage-users.support-team-access.disclaimer-modal-message-first-paragrath'
        }
      />
    </div>
    <div className={`${SUPPORT_ACCESS_DISCLAIMER_BLOCK}__para-2`}>
      <FormattedMessage
        id={
          'project-creation.manage-users.support-team-access.disclaimer-modal-message-sec-paragrath'
        }
      />
    </div>
    <div className={`${SUPPORT_ACCESS_DISCLAIMER_BLOCK}__para-3`}>
      <FormattedMessage
        id={
          'project-creation.manage-users.support-team-access.disclaimer-modal-message-third-paragrath'
        }
      />
    </div>
  </Modal>
);

ViewDisclaimerModal.propTypes = {
  /** function fired to close the modal */
  onClose: PropTypes.func.isRequired,
};
